<template>
  <tabs
    v-if="vendor"
    :tab-name="['Detail', 'Notes']"
    :tab-icon="['event_available', 'text_snippet']"
    class="page-subcategories"
    nav-pills-icons
    color-button="primary"
  >
    <template slot="tab-pane-1">
      <vendor-edit :vendor="vendor" v-on:vendorUpdated="vendorUpdated" />
    </template>

    <template slot="tab-pane-2">
      <vendor-tabs-notes :vendor="vendor" />
    </template>
  </tabs>
</template>

<script>
import { Tabs } from "@/components";
import vendorApi from "@/services/api/vendor";

import VendorEdit from "./VendorEdit";
import VendorTabsNotes from "./VendorTabsNotes";

export default {
  props: ["vendor"],

  components: {
    Tabs,
    VendorEdit,
    VendorTabsNotes
  },

  data() {
    return {};
  },

  computed: {},

  methods: {
    vendorUpdated(updateInfo) {
      this.$emit("vendorUpdated", updateInfo);
    }
  }
};
</script>
